<template>
  <div class="__custom_select" v-click-outside="clickOutsideEvent">
    <div
      class="__select"
      @click="show = true"
      :class="disabled ? '' : ''"
    >
      <div class="text_option">
        {{ selectedBox.length > 1 
          ? `${selectedBox.length} chi nhánh` 
          : selectedBox.length == 1 
            ? `${selectedBox[0].name}`
            : 'Lọc chi nhánh'
        }}
      </div>
    </div>

    <template v-if="show && !disabled">
      <div class="__options" >
        <ul class="__options_items">
          <li>
            <BaseCheckbox v-model="selectAll"/>
            <p class="__options_all">Tất cả chi nhánh</p>
          </li>
          <li
            v-for="(option, index) in listLocation"
            :key="index"
          >
            <BaseCheckbox v-model="selectedBox" :value="option" />
            <p class="__options_name">{{ option.name }}</p>
          </li>
        </ul>
        <div class="__options_btn">
          <div @click="submit()">
            Xác nhận
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import getListLocation from "@/mixins/items/getListLocation";

export default {
  mixins: [
    getListLocation
  ],

  props: {
    disabled: {
      type: Boolean,
      default: false
    },

    value: {
      type: Array,
      default: () => {return []}
    }
  },

  data() {
    return {
      show: false,
      locationSelected: [],
      listLocation: [],
      selectedBox: [],
      listLocationAll:[]
    }
  },

  async created() {
    const list = await this.getListLocation()
    this.listLocationAll = list
    this.listLocation = list.map(e => e)

    this.value.map(e => {
      const result = this.listLocation.findIndex(f => e === f.coLocationId)
      if (result != -1) {
        this.selectedBox.push(this.listLocation[result])
      }
    })

    this.$emit('listLocationAll', this.listLocationAll)
  },

  methods: {
    checkValue(){
      if (this.selectedBox.length == 0) {
        this.selectedBox = this.listLocation
      } else {
        this.selectedBox = []
      }
    },
    checkValueOption(option) {
      const result = this.selectedBox.find(e => JSON.stringify(e) === JSON.stringify(option))

      if (result != -1) {
        this.selectedBox.splice(result, 1)
      } else {
        this.selectedBox.push(option)
      }
    },
    submit() {
      const listLocation = this.selectedBox.map(e => e.coLocationId)
      this.$emit('getLocation', listLocation)
      this.$emit('listLocationAll', this.listLocationAll)
      this.show = false;
    },

    clickOutsideEvent() {
      this.show = false;
      this.selectedBox = []
      this.value.map(e => {
        const result = this.listLocation.findIndex(f => e === f.coLocationId)
        if (result != -1) {
          this.selectedBox.push(this.listLocation[result])
        }
      })
    },
  },


  computed: {
    selectAll: {
      get: function () {
        if (this.selectedBox.length === this.listLocation.length) {
          return "TRUE";
        } else if (this.selectedBox.length === 0) {
          return "FALSE";
        } else {
          return "ORTHER";
        }
      },
      set: function (value) {
        var selected = [];  
        if (value) {
          this.listLocation.map((item) => {
            selected.push(item);
          });
        }
        this.selectedBox = selected;
      },
    },
  },

  watch: {
    value: {
      handler: function () {
        this.selectedBox = []
        this.value.map(e => {
          const result = this.listLocation.findIndex(f => e === f.coLocationId)
          if (result != -1) {
            this.selectedBox.push(this.listLocation[result])
          }
        })
      },
      deep: true
    }
  }
}
</script>

<style lang="scss" scoped>
.__custom_select {
  position: relative;
  width: 220px;
  margin-right: 10px;
  background-color: #fff;

  select {
    display: none;
  }
}
.__select {
  padding: 10px 32px 10px 16px;
  appearance: none;
  height: 40px;
  width: 100%;
  background: #fff;

  border: 1px solid #ddd;
  box-sizing: border-box;
  border-radius: 4px;
  display: flex;

  background: url("data:image/svg+xml,%3Csvg width='8' height='6' viewBox='0 0 8 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.94 0.892578L4 3.94591L7.06 0.892578L8 1.83258L4 5.83258L0 1.83258L0.94 0.892578Z' fill='%23636678'/%3E%3C/svg%3E%0A")
    center right 16px no-repeat;

  cursor: pointer;
}

.__options {
  position: absolute;
  z-index: 999999999;
  top: 46px;
  width: 100%;
  background: #fff;

  border: 1px solid #ddd;

  // border: 1px solid #3e69f6;
  overflow: hidden;
  border-radius: 4px;

  &_btn {
    padding: 12px 16px;
    display: flex;
    justify-content: flex-end;
    cursor: pointer;

    div {
      margin-left: 8px;
      font-size: 12px;
      font-weight: 700;
      padding: 4px 8px;
      color: #fff;
      background: #28a745;
    }
  }

  > ul.__options_items {
    margin: unset;
    padding: unset;
    border-top: 1px solid #ddd;

    max-height: 40vh;
    overflow-y: scroll;

    > li {
      padding: 12px 16px;
      cursor: pointer;
      color: #9093a4;
      display: flex;
      align-items: center;

      p {
        margin: 0px !important;
        width: 200px;
        overflow: hidden;
        white-space: nowrap; 
        text-overflow: ellipsis;
      }

      .__options_all {
        font-weight: 900;
      }

      &:hover {
        background: #3e69f61a;
        color: #3e69f6;
      }
      &:not(:first-child) {
        border-top: 1px solid #ddd;
      }
      &.__option_selected {
        background: #3e69f61a;
        color: #495057;
      }
    }

    &:hover {
      > li.__option_selected {
        background: transparent;
        &:hover {
          background: #3e69f61a;
          color: #495057;
        }
      }
    }
  }
}

.disabled_select {
  background-color: #f2f3f4;
}

.text_option {
  overflow: hidden;
  text-overflow: ellipsis;

  @media screen and (max-width: 705px) {
    max-width: 400px;
  }
  @media screen and (max-width: 605px) {
    max-width: 300px;
  }
  @media screen and (max-width: 505px) {
    max-width: 200px;
  }
  @media screen and (max-width: 405px) {
    max-width: 200px;
  }
}
</style>